import React, { useEffect, useMemo, useState } from "react";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { useGetAllUsersListQuery } from "../../../user/users/usersApi";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";
import { createClickableLink } from "../../../../components/common/datatable/DataTableUtils";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import {
    SearchSelectWithEnum,
    SearchSelectWithList
} from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { SearchDatePickerWrapper } from "../../../../components/common/datatable/filter/SearchDatePickerWrapper";
import { formatValueAsDateAndTime } from "../../../../helpers/utils/DateUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { useLazyExportOrderEventDataQuery, useSearchOrderEventApiQuery } from "../orderEventApi";


const OrderEvent = () => {

    const [triggerExportOrderEventDataQuery] = useLazyExportOrderEventDataQuery();
    const { data: enums } = useGetEnumsQuery("")
    const useListApi = useGetAllUsersListQuery("");
    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Order Events");


    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Order Events", url: "" }]
    )
    useEffect(() => {

        document.title = 'Order Events';
    }, []);


    const columns: DataTableColumn[] = [
        {
            label: "Order No.", accessor: "order.customerOrderNumber", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                if (!props.row.original.order?.id) {
                    return props.value;
                }
                let path = "/orders/" + props.row.original.order.id;
                return createClickableLink(path, props.value, userSetting);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Order No..."}
                    name={"customerOrderNumber"} accessor={"orderNumber"} />,
                overrideFilterAccessor: "orderNumber"
            }]
        },
        {
            label: "Event Name", accessor: "eventName", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return <span>{getEnumDisplayNameByConstant(enums?.["EventName"], props.value)}</span>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["EventName"], "Select Event Name(s)...", true, "eventName"),
                overrideFilterAccessor: "eventName",
                overrideFilterLabel: "Event Name(s)",
            }],
        },
        {
            label: "Order Status", accessor: "orderEventData.orderStatus",
            cell: (props: any) => {
                return <>
                    <span>{getEnumDisplayNameByConstant(enums?.["OrderStatus"], props.value)}</span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["OrderStatus"], "Select Order Status(es)...", true, "orderStatus"),
                overrideFilterAccessor: "orderStatus",
                overrideFilterLabel: "Order Status(es)",
            }],
        },
        {
            label: "Product Status", accessor: "orderEventData.productStatus",
            cell: (props: any) => {
                return <>
                    <span>{getEnumDisplayNameByConstant(enums?.["ProductStatus"], props.value)}</span>

                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["ProductStatus"], "Select Product Status(es)...", true, "productStatus"),
                overrideFilterAccessor: "productStatus",
                overrideFilterLabel: "Product Status(es)",
            }],
        },
        {
            label: "Assigned To", accessor: "assignedTo",
            filterOptions: [{
                filterComponent: SearchSelectWithList(useListApi.data, "username", "id", "Enter Assigned To...", false, "assignedTo"),
                overrideFilterAccessor: "assignedTo",
            }],
        },
        {
            label: "Task Status", accessor: "orderEventData.taskStatus", visibility: { hasShowSetting: true,canColumnShow:true},
            cell: (props: any) => {
                return <>
                    <span>{getEnumDisplayNameByConstant(enums?.["TaskStatus"], props.value)}</span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["TaskStatus"], "Select Task Status(es)...", true, "taskStatus"),
                overrideFilterAccessor: "taskStatus",
                overrideFilterLabel: "Task Status(es)",
            }],
        },
        {
            label: "Event Time", accessor: "eventTime", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return formatValueAsDateAndTime(props.value);
            },
            filterOptions: [
                {
                    filterComponent: <SearchDatePickerWrapper
                        accessor={"eventDateFrom"} />,
                    overrideFilterAccessor: "eventDateFrom",
                    overrideFilterLabel: "Event Date - From",
                },
                {
                    filterComponent: <SearchDatePickerWrapper accessor={"eventDateTo"} />,
                    overrideFilterAccessor: "eventDateTo",
                    overrideFilterLabel: "Event Date - To",
                }]
        }
    ]

    return (
        <div className="px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>
            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchOrderEventApiQuery,
                    exportAction: triggerExportOrderEventDataQuery
                }}
                userSettingGroup={"Order Events"}
                basePermission={"ORDREVNT"}
            />
        </div>
    );
};

export default OrderEvent;

